module.exports = __webpack_public_path__ + "img/asset_MNDE.1ad34a37.svg";